"use client";
import { useAuth0V2 } from "@stadium/services/auth0";
import { getOriginLoginParams } from "@stadium/services/auth/utils";
import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";

import Button from "@stadium/shared/src/components/shared/button";

import { LOGIN_CTA, LOGIN_CTA_SERVICES, NAVBAR } from "constants/june-so";

const AuthLogin = ({ children, className = "", loginOptions = {}, render, isButtonWrapped }) => {
  const { loginWithRedirect } = useAuth0V2();
  const { returnTo = "", loginCallback = "", ...restLoginOptions } = loginOptions;
  const { trackEvent } = useJuneSoEventTracking({ services: LOGIN_CTA_SERVICES });
  const onClick = (params = {}) => {
    trackEvent({
      componentName: NAVBAR,
      target: LOGIN_CTA,
    });
    loginWithRedirect({
      redirectUri: window.location.origin + loginCallback,
      appState: { returnTo: returnTo || window.location.href },
      ...restLoginOptions,
      ...params,
      ...getOriginLoginParams(),
    });
  };

  if (render) return render({ handleOnClick: onClick });

  return isButtonWrapped ? (
    <Button onClick={onClick} className={className} styleType="primary-outline">
      {children}
    </Button>
  ) : (
    <div onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default AuthLogin;
